import * as React from "react";
const Mail = (props) => (
  <svg
    width={25}
    height={21}
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.4375 0H0V3.39819L12.2188 10.0625L24.4375 3.39699V0Z"
      fill="white"
    />
    <path
      d="M24.4375 5.75L12.2188 11.9209L0 5.75111V20.125H24.4375V5.75Z"
      fill="white"
    />
  </svg>
);
export default Mail;
